import React from 'react';
import './statusList.scss';
import { isAOIOrder } from 'common/constants/app.constants';

const StatusList = ({ feasibleSites = '', manualFeasibleSites = '', notFeasibleSites = '', pendingFeasibleSites = '', pendingForThirdPartySites = '', incompleteAddr = '' }) => {
  return isAOIOrder ? (
    <React.Fragment>
      <ul className="status_items">
        {feasibleSites > 0 && (
          <span className="text_status text_status_resolved fsb-status">
            {feasibleSites} {feasibleSites > 1 ? 'Sites' : 'Site'} Feasible
          </span>
        )}
        {incompleteAddr > 0 && (
          <span className="text_status text_status_warning fsb-status">
            {incompleteAddr} {incompleteAddr > 1 ? 'Locations' : 'Location'} with incomplete address.
          </span>
        )}
        {manualFeasibleSites > 0 && (
          <span className="text_status text_status_warning fsb-status">
            {manualFeasibleSites} {manualFeasibleSites > 1 ? 'Sites' : 'Site'} Manual Feasibility Required
          </span>
        )}
        {notFeasibleSites > 0 && (
          <span className="text_status text_status_error fsb-status">
            {notFeasibleSites} {notFeasibleSites > 1 ? 'Sites' : 'Site'} Not Feasible
          </span>
        )}
        {pendingFeasibleSites > 0 && (
          <span className="text_status text_status_pending fsb-status">
            {pendingFeasibleSites} {pendingFeasibleSites > 1 ? 'Sites' : 'Site'} Pending Feasibility{' '}
          </span>
        )}
        {pendingForThirdPartySites > 0 && (
          <span className="text_status text_status_pending fsb-status">
            {pendingForThirdPartySites} {pendingForThirdPartySites > 1 ? 'Sites' : 'Site'} Pending For Third Party{' '}
          </span>
        )}
      </ul>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <ul className="status_items">
        {feasibleSites > 0 && (
          <li>
            <span className="text_status text_status_resolved">
              {feasibleSites} {feasibleSites > 1 ? 'Sites' : 'Site'} Feasible
            </span>
          </li>
        )}
        {manualFeasibleSites > 0 && (
          <li>
            <span className="text_status text_status_warning">
              {manualFeasibleSites} {manualFeasibleSites > 1 ? 'Sites' : 'Site'} Manual Feasibility Required
            </span>
          </li>
        )}
        {notFeasibleSites > 0 && (
          <li>
            <span className="text_status text_status_error">
              {notFeasibleSites} {notFeasibleSites > 1 ? 'Sites' : 'Site'} Not Feasible
            </span>
          </li>
        )}
        {pendingFeasibleSites > 0 && (
          <li>
            <span className="text_status text_status_pending">
              {pendingFeasibleSites} {pendingFeasibleSites > 1 ? 'Sites' : 'Site'} Pending Feasibility{' '}
            </span>
          </li>
        )}
        {pendingForThirdPartySites > 0 && (
          <li>
            <span className="text_status text_status_pending">
              {pendingForThirdPartySites} {pendingForThirdPartySites > 1 ? 'Sites' : 'Site'} Pending For Third Party{' '}
            </span>
          </li>
        )}
      </ul>
    </React.Fragment>
  );
};

export default StatusList;
